<script>
  import { navigate } from 'svelte-routing';
  export let time;
  export let timeAgoStr;
  export let title;
  export let url = '';
  export let item;
  import * as bootstrap from 'bootstrap';
  import { onDestroy, onMount } from 'svelte';
  let tooltipTriggerEl;
  let tooltipEl;
  onMount(() => {
    if (tooltipTriggerEl) {
      tooltipEl = new bootstrap.Tooltip(tooltipTriggerEl, {
        delay: 100,
        html: true,
      });
    }
  });
  onDestroy(() => {
    if (tooltipTriggerEl) {
      tooltipEl.hide();
    }
  });
</script>

<button
  class="border-0 bg-transparent p-0"
  on:click={() => {
    if (url != null && url.trim() != '') {
      navigate(url);
    }
  }}
>
  <div class="notifications-list px-3 py-2">
    <div class="d-flex flex-row align-items-center">
      <div
        class="background-blue me-1 icon-notification-type d-flex align-items-center justify-content-center me-3"
      >
        <img
          class="icon-16"
          alt=""
          src="/images/calendar-white.svg"
        />
      </div>
      <div class="w-100 d-flex flex-row justify-content-between text-start">
        <div class="text-black text-break">
          <span>{@html title}</span>
          {#if item.showTooltip == 1}
            <button
              class="btn btn-link d-inline-block p-0"
              on:click={(e) => e.preventDefault()}
              bind:this={tooltipTriggerEl}
              data-bs-placement="bottom"
              title={item.tooltip}
              ><img
                class=" icon-14"
                alt=""
                src="/images/info.svg"
              /></button
            >
          {/if}
        </div>
        <div class="time-stamp-block text-end">
          <img
            alt=""
            class="icon-14 me-1"
            src="/images/clock.svg"
          />
          <span class="text-muted font-size-11">{timeAgoStr}</span>
        </div>
      </div>
    </div>
  </div>
</button>

<style lang="scss">
  .notifications-list {
    margin-left: -1rem;
    margin-right: -1rem;
    background-color: rgba($input-border-color, 0.2);
    border-bottom: 2px solid $white-color;
    .icon-notification-type {
      width: 40px;
      height: 40px;
      border-radius: 40px;
    }
    &:hover {
      background-color: rgba($input-border-color, 0.4);
      transition: all 0.4s ease-in-out;
      -webkit-transition: all 0.4s ease-in-out;
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    75% {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  .time-stamp-block {
    width: 200px;
    flex: 0 0 200px;
  }
</style>
